import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight, Phone, Clock, Calendar } from "lucide-react";
import { useDemoPopup } from "@/pages/LandingPage";

export const FinalCTA = () => {
  const { openDemoPopup } = useDemoPopup();

  return (
    <section id="cta" className="py-14 lg:py-28 bg-slate-900">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          {/* Title */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-6 tracking-tight">
            Prêt à remplir{" "}
            <span className="text-accent">votre carnet de commandes ?</span>
          </h2>
          
          <p className="text-lg text-slate-400 mb-10 max-w-2xl mx-auto">
            Nouveaux clients, appels gérés 24/7, devis relancés automatiquement. Recevez une démo personnalisée.
          </p>

          {/* Features */}
          <div className="flex flex-wrap justify-center gap-8 mb-10">
            {[
              { icon: Phone, label: "Démo par IA" },
              { icon: Clock, label: "Appel immédiat" },
              { icon: Calendar, label: "Prise de RDV auto" },
            ].map((item, index) => {
              const Icon = item.icon;
              return (
                <div key={item.label} className="flex items-center gap-2 text-slate-400">
                  <Icon className="w-5 h-5 text-accent" />
                  <span className="font-medium">{item.label}</span>
                </div>
              );
            })}
          </div>

          {/* CTA Button */}
          <Button
            onClick={openDemoPopup}
            size="lg"
            className="bg-accent hover:bg-orange-600 text-white shadow-lg font-bold text-base sm:text-xl px-6 sm:px-12 py-5 sm:py-8 rounded-md transition-all hover:scale-105 hover:shadow-xl w-full sm:w-auto max-w-full"
            data-testid="final-cta-button"
          >
            <Phone className="mr-2 sm:mr-3 w-5 h-5 sm:w-6 sm:h-6" />
            Recevoir ma démo gratuite
            <ArrowRight className="ml-2 sm:ml-3 w-5 h-5 sm:w-6 sm:h-6" />
          </Button>

          {/* Urgency */}
          <p className="text-sm text-slate-500 mt-8">
            Notre IA vous appelle dans les minutes qui suivent
          </p>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
